module.exports = require('./dist/lib/error')
